import { registerAction } from '../../Action'

const LOAD_PRESENTATION_COUNTS = 'LOAD_PRESENTATION_COUNTS'

const reducer = (state = {}, action) => {
  const { posts_count, moments_count, slides_count } = action.payload
  return {
    ...state,
    new_presentation_counts: {
      posts_count,
      moments_count,
      slides_count,
    },
  }
}

const loadPresentationCounts = registerAction(LOAD_PRESENTATION_COUNTS, {
  reducer,
})

export default loadPresentationCounts
